/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const heart_rate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.244 9.117h2.811a.234.234 0 0 0 .21-.13l1.071-2.144a.234.234 0 0 1 .436.037l1.046 3.485a.234.234 0 0 0 .436.025l.977-2.28a.234.234 0 0 1 .409-.038l.694 1.042h3.423M14.969 6a3.534 3.534 0 0 0-1.407-3.314 3.53 3.53 0 0 0-4.588.348L8 4.008l-.975-.971A3.53 3.53 0 0 0 1.031 6m8.609 6.54L8.336 13.9a.465.465 0 0 1-.673 0L6.36 12.54"
    />
  </svg>
)
export default heart_rate
